import { REDUX_ACTIONS } from '../../shared/config/constants';

const initialState = {
  loading: false,
  data: [],
  errorMessage: '',
  wellUsers: {
    data: {},
    loading: false,
    errorMessage: ''
  }
};

const permissionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REDUX_ACTIONS.PERMISSIONS_LIST_LOADING:
      return {
        ...state,
        loading: true,
        errorMessage: '',
      };
    case REDUX_ACTIONS.PERMISSIONS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [...action.payload.emailsData],
        permissionsData: { ...action.payload.permissions },
        errorMessage: '',
      };
    case REDUX_ACTIONS.PERMISSIONS_LIST_ERROR:
      return {
        ...state,
        loading: false,
        errorMessage: action.payload.message,
        data: [],
        permissionsData: {}
      };
    case REDUX_ACTIONS.PERMISSIONS_LIST_RESET:
      return {
        ...initialState,
      };
    case REDUX_ACTIONS.PERMISSIONS_WELLS_USERS_LOADING:
      return {
        ...state,
        wellUsers: {
          ...state.wellUsers,
          loading: true,
          errorMessage: '',
        }
      };
    case REDUX_ACTIONS.PERMISSIONS_WELLS_USERS_SUCESS:
      return {
        ...state,
        wellUsers: {
          ...state.wellUsers,
          loading: false,
          data: [...action.payload],
          errorMessage: '',
        }
      };
    case REDUX_ACTIONS.PERMISSIONS_WELLS_USERS_ERROR:
      return {
        ...state,
        wellUsers: {
          ...state.wellUsers,
          loading: false,
          errorMessage: action.payload.message,
          data: [],
        }
      };
    default:
      return state;
  }
};

export default permissionsReducer;
